/**
 * @generated SignedSource<<7d050301126155213148eead5d87dde2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentPixCreditOptions_charge$data = {
  readonly availablePaymentMethods: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly availablePaymentMethodsPixCredit: {
    readonly options: ReadonlyArray<{
      readonly discount: number | null | undefined;
      readonly installmentNumber: number;
      readonly installmentValue: number;
      readonly valueInCash: number;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly valueWithDiscount: number | null | undefined;
  readonly " $fragmentType": "PaymentPixCreditOptions_charge";
};
export type PaymentPixCreditOptions_charge$key = {
  readonly " $data"?: PaymentPixCreditOptions_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentPixCreditOptions_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentPixCreditOptions_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "valueWithDiscount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "availablePaymentMethods",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PaymentMethodAvailablePixCredit",
      "kind": "LinkedField",
      "name": "availablePaymentMethodsPixCredit",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PaymentMethodAvailablePixCreditOption",
          "kind": "LinkedField",
          "name": "options",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "valueInCash",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "installmentNumber",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "installmentValue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "discount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "26dcec21764e407700fde5eb7af9f6ca";

export default node;
